var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PyJobRequest_1;
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-usages-domain'; // force import for JsonSchema
import { EngineMode } from '@symon-ai/wisepipe-base-pipe';
import { PythonEngineVersion } from './pythonEngineVersion';
import { JobRequest } from './jobRequest';
const MAX_TIMEOUT = 4 * 60 * 60 * 1000; // 4 hour
const schema = {
    $id: 'urn:wisepipe-python-job-domain:PyJobRequest',
    type: 'object',
    properties: {
        route: { type: 'string', minLength: 1, maxLength: 200 },
        code: { type: 'string', minLength: 1 },
        call: { type: 'string', minLength: 1 },
        timeoutMs: { type: 'number', minimum: 1 },
        shortWait: { type: 'boolean' },
        pythonEngineVersion: {
            type: 'string',
            enum: Object.values(PythonEngineVersion)
        },
        highMemory: { type: 'boolean' }
    },
    required: ['route', 'code', 'call', 'timeoutMs']
};
let PyJobRequest = PyJobRequest_1 = class PyJobRequest extends JobRequest {
    constructor(orgID, requester, route, code, call, timeoutMs, shortWait, usage, pythonEngineVersion, pyJobRequestType, highMemory) {
        super(EngineMode.Standard, requester, orgID, usage, pyJobRequestType);
        const trimmed = call.trim();
        if (!this.isCallValid(trimmed)) {
            throw new Error(`call argument must be a 1 line expression`);
        }
        if (timeoutMs <= 0 && timeoutMs !== -1) {
            throw new Error(`Invalid value for timeoutMs: must be > 0 or -1 (for max timeout)`);
        }
        this.route = route;
        this.code = code;
        this.call = trimmed;
        this.timeoutMs = timeoutMs === -1 ? MAX_TIMEOUT : timeoutMs;
        this.shortWait = shortWait === undefined ? false : shortWait;
        this.pythonEngineVersion = pythonEngineVersion;
        this.highMemory = highMemory;
        JSON.validate(this, PyJobRequest_1);
    }
    isCallValid(call) {
        // remove quoted text
        const qouteSymbols = ["'''", '"', "'"];
        const MAX_SYMBOL_LENGTH = 3;
        let match = qouteSymbols;
        let inQuotes = false;
        const prev = [];
        for (const ch of call) {
            // keep track of enough previous symbols find a match
            prev.push(ch);
            if (prev.length > MAX_SYMBOL_LENGTH) {
                prev.shift();
            }
            // Invalid?
            if (!inQuotes && ch === '\n') {
                return false; // yes, 1 line only
            }
            // match targeted symbol?
            for (const symbol of match) {
                if (PyJobRequest_1.isSymbolMatch(symbol, prev)) {
                    inQuotes = !inQuotes;
                    match = inQuotes ? [symbol] : qouteSymbols;
                    if (symbol.length === MAX_SYMBOL_LENGTH)
                        prev.length = 0;
                    break;
                }
            }
        }
        return true;
    }
    static isSymbolMatch(symbol, prev) {
        if (prev.length < symbol.length)
            return false;
        const offset = prev.length - symbol.length;
        for (let i = 0; i < symbol.length; ++i) {
            if (prev[offset + i] !== symbol[i])
                return false;
        }
        return true;
    }
};
PyJobRequest.MAX_TIMEOUT = MAX_TIMEOUT;
PyJobRequest = PyJobRequest_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(EngineMode.Standard)
], PyJobRequest);
export { PyJobRequest };
//# sourceMappingURL=pyJobRequest.js.map